import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonFeaturesRoutingModule } from './common-features-routing-module';
import { SharedModule } from '../../shared/shared-module';
import { ArticleFilter } from './article-filter/article-filter';
import { Banner } from './banner/banner';
import { CategoryCarousel } from './category-carousel/category-carousel';
import { ProductCard } from './product-card/product-card';
import { DeleteDialog } from './delete-dialog/delete-dialog';
import { Header } from './header/header';
import { Footer } from './footer/footer';
import { Help } from './help/help';
import { SideNavigation } from './side-navigation/side-navigation';
// import { TradeGpt } from '../features/trade-gpt/trade-gpt-ui/trade-gpt/trade-gpt';
import { ViewUploadedFile } from './view-uploaded-file/view-uploaded-file';
// import { RequirementList } from '../features/requirement/requirement-list/requirement-list';
// import { UpdateRequirement } from './update-requirement/update-requirement';
import { ShipmentTracking } from './shipment-tracking/shipment-tracking';
import { SucessErrorDialog } from './sucess-error-dialog/sucess-error-dialog';
import { SuccessDialog } from './success-dialog/success-dialog';
import { LogoutDialog } from './logout-dialog/logout-dialog';
import { CookieSettings } from './cookie-settings/cookie-settings';
import { CookiePreferences } from './cookie-preferences/cookie-preferences';


@NgModule({
  declarations: [
    ArticleFilter,
    Banner,
    CategoryCarousel,
    ProductCard,
    DeleteDialog,
    Header,
    Footer,
    Help,
    SideNavigation,
    ViewUploadedFile,
    ShipmentTracking,
    SucessErrorDialog,
    SuccessDialog,
    LogoutDialog,
    CookieSettings,
    CookiePreferences
  ],
  imports: [
    CommonModule,
    CommonFeaturesRoutingModule,
    SharedModule
  ],
  exports:[
    ArticleFilter,
    Banner,
    CategoryCarousel,
    ProductCard,
    DeleteDialog,
    Header,
    Footer,
    Help,
    SideNavigation,
    ViewUploadedFile,
    ShipmentTracking,
    SucessErrorDialog,
    CookieSettings,
    CookiePreferences
  ]
})
export class CommonFeaturesModule { }
